import {defineStore} from "pinia";
import {createBaseStore} from "@/stores/base";

export const useAbsenceStore = defineStore('absence', createBaseStore(
        '/abmeldungen',
        {
            currentSort: [
                {col: 'endDate', sortDir: 'desc'}
            ]
        },
    {
        async bulkCreateAbsences(absenceBulkData) {
            try {
                await this.axios.post('/abmeldungen/bulk/', absenceBulkData);
                await this.getData();
            } catch (e) {
                console.log(e);
            }
        }
    },
        {}
    )
)